import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';
import LinkField from 'components/LinkField';
import DateTimeField from 'components/DateTimeField';

const EducationShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <LinkField label="Professional ID" source="professional_id" />
      <TextField label="School Name" source="school_name" />
      <TextField label="Degree Type" source="degree_type" />
      <TextField label="Field of Study" source="field_of_study" />
      <TextField label="City" source="city" />
      <TextField label="State" source="state.name" />
      <DateTimeField label="Start Date" source="start_date" />
      <DateTimeField label="End Date" source="end_date" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

EducationShow.query = gql`
  query GET_ONE($id: Int!) {
    education(id: $id) {
      id
      city
      created_at
      degree_type
      end_date
      field_of_study
      school_name
      location
      professional_id
      start_date
      state {
        id
        name
      }
      state_id
      updated_at
    }
  }
`;

export default EducationShow;
